import { render, staticRenderFns } from "./ClaimRejectionInfo.vue?vue&type=template&id=4d723e41"
import script from "./ClaimRejectionInfo.vue?vue&type=script&lang=js"
export * from "./ClaimRejectionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports